import axios, { AxiosResponse } from "axios";

type DownloadCasesExcel = (
  url: string,
  headers: any,
  signal: AbortSignal,
  getTokenCallback?: () => Promise<string>,
  data?: any,
  filename?: string
) => Promise<void>;

export const downloadCasesExcel: DownloadCasesExcel = async (
  url,
  headers,
  signal,
  getTokenCallback,
  data,
  filename = "download"
) => {
  let accessToken: string | undefined;
  try {
    accessToken = await getTokenCallback?.();
  } catch (err) {
    const error = err as Error;
    console.error("Error getting token:", error.message);
    return;
  }

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  let res: AxiosResponse<any, any>;
  try {
    res = await axios.post(url, data, {
      responseType: "blob",
      headers,
      signal
    });
  } catch (err) {
    const error = err as Error;
    console.error("Error downloading file:", error.message);
    return;
  }

  const objectUrl = window.URL.createObjectURL(res.data);
  const anchor = document.createElement("a");
  document.body.appendChild(anchor);
  anchor.href = objectUrl;
  anchor.download = filename;
  anchor.click();
  window.URL.revokeObjectURL(objectUrl);
};
